// Shared documentary/field-research photography for each research domain.
// Real stock photography (Pexels / Unsplash) — quiet, human, non-AI.

export const HERO_BG = 'https://images.pexels.com/photos/34657697/pexels-photo-34657697.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1600';

export const DOMAIN_IMAGES = {
  electroculture: 'https://images.pexels.com/photos/9007626/pexels-photo-9007626.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
  atmospheric: 'https://images.pexels.com/photos/9751579/pexels-photo-9751579.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
  resonance: 'https://images.pexels.com/photos/9817391/pexels-photo-9817391.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
  water: 'https://images.pexels.com/photos/34155535/pexels-photo-34155535.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
  offgrid: 'https://images.unsplash.com/photo-1668015642564-1d68397e77a8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwxfHxkYXJrJTIwb2ZmJTIwZ3JpZCUyMGNhYmluJTIwc29sYXIlMjBhcmNoaXRlY3R1cmV8ZW58MHx8fHwxNzgwNzg0NTgzfDA&ixlib=rb-4.1.0&q=85',
  field: 'https://images.pexels.com/photos/1366942/pexels-photo-1366942.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
};

// Resolve a domain photo from a (possibly messy) category name.
export const domainImage = (categoryName = '') => {
  const n = (categoryName || '').toLowerCase();
  if (n.includes('electro')) return DOMAIN_IMAGES.electroculture;
  if (n.includes('atmospher')) return DOMAIN_IMAGES.atmospheric;
  if (n.includes('resonan') || n.includes('frequenc')) return DOMAIN_IMAGES.resonance;
  if (n.includes('water')) return DOMAIN_IMAGES.water;
  if (n.includes('off')) return DOMAIN_IMAGES.offgrid;
  return DOMAIN_IMAGES.field;
};
